import { render, staticRenderFns } from "./LeadsCardSms.vue?vue&type=template&id=cafe500c&scoped=true&"
import script from "./LeadsCardSms.vue?vue&type=script&lang=js&"
export * from "./LeadsCardSms.vue?vue&type=script&lang=js&"
import style0 from "./LeadsCardSms.vue?vue&type=style&index=0&id=cafe500c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafe500c",
  null
  
)

export default component.exports